// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/session.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";

/**
 * @generated from enum gitpod.v1.SessionPhase
 */
export enum SessionPhase {
  /**
   * @generated from enum value: SESSION_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SESSION_PHASE_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: SESSION_PHASE_ARCHIVED = 2;
   */
  ARCHIVED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(SessionPhase)
proto3.util.setEnumType(SessionPhase, "gitpod.v1.SessionPhase", [
  { no: 0, name: "SESSION_PHASE_UNSPECIFIED" },
  { no: 1, name: "SESSION_PHASE_ACTIVE" },
  { no: 2, name: "SESSION_PHASE_ARCHIVED" },
]);

/**
 * @generated from enum gitpod.v1.SessionResourceKind
 */
export enum SessionResourceKind {
  /**
   * @generated from enum value: SESSION_RESOURCE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SESSION_RESOURCE_KIND_ISSUE = 3;
   */
  ISSUE = 3,

  /**
   * @generated from enum value: SESSION_RESOURCE_KIND_PULL_REQUEST = 4;
   */
  PULL_REQUEST = 4,

  /**
   * @generated from enum value: SESSION_RESOURCE_KIND_DOCUMENTATION = 5;
   */
  DOCUMENTATION = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(SessionResourceKind)
proto3.util.setEnumType(SessionResourceKind, "gitpod.v1.SessionResourceKind", [
  { no: 0, name: "SESSION_RESOURCE_KIND_UNSPECIFIED" },
  { no: 3, name: "SESSION_RESOURCE_KIND_ISSUE" },
  { no: 4, name: "SESSION_RESOURCE_KIND_PULL_REQUEST" },
  { no: 5, name: "SESSION_RESOURCE_KIND_DOCUMENTATION" },
]);

/**
 * @generated from enum gitpod.v1.SessionResourceRole
 */
export enum SessionResourceRole {
  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_OWNED = 1;
   */
  OWNED = 1,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_PRIMARY = 2;
   */
  PRIMARY = 2,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_SUBAGENT = 3;
   */
  SUBAGENT = 3,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_FIXES = 4;
   */
  FIXES = 4,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_BLOCKED_BY = 5;
   */
  BLOCKED_BY = 5,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_BLOCKS = 6;
   */
  BLOCKS = 6,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_REVIEWS = 7;
   */
  REVIEWS = 7,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_CREATED = 8;
   */
  CREATED = 8,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_REFERENCES = 9;
   */
  REFERENCES = 9,
}
// Retrieve enum metadata with: proto3.getEnumType(SessionResourceRole)
proto3.util.setEnumType(SessionResourceRole, "gitpod.v1.SessionResourceRole", [
  { no: 0, name: "SESSION_RESOURCE_ROLE_UNSPECIFIED" },
  { no: 1, name: "SESSION_RESOURCE_ROLE_OWNED" },
  { no: 2, name: "SESSION_RESOURCE_ROLE_PRIMARY" },
  { no: 3, name: "SESSION_RESOURCE_ROLE_SUBAGENT" },
  { no: 4, name: "SESSION_RESOURCE_ROLE_FIXES" },
  { no: 5, name: "SESSION_RESOURCE_ROLE_BLOCKED_BY" },
  { no: 6, name: "SESSION_RESOURCE_ROLE_BLOCKS" },
  { no: 7, name: "SESSION_RESOURCE_ROLE_REVIEWS" },
  { no: 8, name: "SESSION_RESOURCE_ROLE_CREATED" },
  { no: 9, name: "SESSION_RESOURCE_ROLE_REFERENCES" },
]);

/**
 * @generated from message gitpod.v1.Session
 */
export class Session extends Message<Session> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * @generated from field: gitpod.v1.SessionPhase phase = 4;
   */
  phase = SessionPhase.UNSPECIFIED;

  /**
   * @generated from field: repeated gitpod.v1.SessionResource resources = 5;
   */
  resources: SessionResource[] = [];

  /**
   * orchestrator_agent_execution_id is the agent execution that drives this session's name.
   * The first agent execution linked to a session becomes its orchestrator.
   *
   * @generated from field: string orchestrator_agent_execution_id = 6;
   */
  orchestratorAgentExecutionId = "";

  constructor(data?: PartialMessage<Session>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Session";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "phase", kind: "enum", T: proto3.getEnumType(SessionPhase) },
    { no: 5, name: "resources", kind: "message", T: SessionResource, repeated: true },
    { no: 6, name: "orchestrator_agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Session {
    return new Session().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Session {
    return new Session().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Session {
    return new Session().fromJsonString(jsonString, options);
  }

  static equals(a: Session | PlainMessage<Session> | undefined, b: Session | PlainMessage<Session> | undefined): boolean {
    return proto3.util.equals(Session, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SessionResource
 */
export class SessionResource extends Message<SessionResource> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gitpod.v1.SessionResourceKind kind = 2;
   */
  kind = SessionResourceKind.UNSPECIFIED;

  /**
   * @generated from field: gitpod.v1.SessionResourceRole role = 3;
   */
  role = SessionResourceRole.UNSPECIFIED;

  /**
   * @generated from field: optional string url = 6;
   */
  url?: string;

  /**
   * @generated from field: optional string title = 7;
   */
  title?: string;

  /**
   * @generated from field: optional string description = 8;
   */
  description?: string;

  constructor(data?: PartialMessage<SessionResource>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SessionResource";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "kind", kind: "enum", T: proto3.getEnumType(SessionResourceKind) },
    { no: 3, name: "role", kind: "enum", T: proto3.getEnumType(SessionResourceRole) },
    { no: 6, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SessionResource {
    return new SessionResource().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SessionResource {
    return new SessionResource().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SessionResource {
    return new SessionResource().fromJsonString(jsonString, options);
  }

  static equals(a: SessionResource | PlainMessage<SessionResource> | undefined, b: SessionResource | PlainMessage<SessionResource> | undefined): boolean {
    return proto3.util.equals(SessionResource, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateSessionRequest
 */
export class CreateSessionRequest extends Message<CreateSessionRequest> {
  /**
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 2;
   */
  description?: string;

  constructor(data?: PartialMessage<CreateSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSessionRequest {
    return new CreateSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSessionRequest {
    return new CreateSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSessionRequest {
    return new CreateSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSessionRequest | PlainMessage<CreateSessionRequest> | undefined, b: CreateSessionRequest | PlainMessage<CreateSessionRequest> | undefined): boolean {
    return proto3.util.equals(CreateSessionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateSessionResponse
 */
export class CreateSessionResponse extends Message<CreateSessionResponse> {
  /**
   * @generated from field: gitpod.v1.Session session = 1;
   */
  session?: Session;

  constructor(data?: PartialMessage<CreateSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session", kind: "message", T: Session },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSessionResponse {
    return new CreateSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSessionResponse {
    return new CreateSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSessionResponse {
    return new CreateSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSessionResponse | PlainMessage<CreateSessionResponse> | undefined, b: CreateSessionResponse | PlainMessage<CreateSessionResponse> | undefined): boolean {
    return proto3.util.equals(CreateSessionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetSessionRequest
 */
export class GetSessionRequest extends Message<GetSessionRequest> {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId = "";

  constructor(data?: PartialMessage<GetSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSessionRequest {
    return new GetSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSessionRequest {
    return new GetSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSessionRequest {
    return new GetSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSessionRequest | PlainMessage<GetSessionRequest> | undefined, b: GetSessionRequest | PlainMessage<GetSessionRequest> | undefined): boolean {
    return proto3.util.equals(GetSessionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetSessionResponse
 */
export class GetSessionResponse extends Message<GetSessionResponse> {
  /**
   * @generated from field: gitpod.v1.Session session = 1;
   */
  session?: Session;

  constructor(data?: PartialMessage<GetSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session", kind: "message", T: Session },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSessionResponse {
    return new GetSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSessionResponse {
    return new GetSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSessionResponse {
    return new GetSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSessionResponse | PlainMessage<GetSessionResponse> | undefined, b: GetSessionResponse | PlainMessage<GetSessionResponse> | undefined): boolean {
    return proto3.util.equals(GetSessionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListSessionsRequest
 */
export class ListSessionsRequest extends Message<ListSessionsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: optional gitpod.v1.SessionPhase phase = 2;
   */
  phase?: SessionPhase;

  constructor(data?: PartialMessage<ListSessionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListSessionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "phase", kind: "enum", T: proto3.getEnumType(SessionPhase), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSessionsRequest {
    return new ListSessionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSessionsRequest {
    return new ListSessionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSessionsRequest {
    return new ListSessionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSessionsRequest | PlainMessage<ListSessionsRequest> | undefined, b: ListSessionsRequest | PlainMessage<ListSessionsRequest> | undefined): boolean {
    return proto3.util.equals(ListSessionsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListSessionsResponse
 */
export class ListSessionsResponse extends Message<ListSessionsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Session sessions = 2;
   */
  sessions: Session[] = [];

  constructor(data?: PartialMessage<ListSessionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListSessionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "sessions", kind: "message", T: Session, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSessionsResponse {
    return new ListSessionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSessionsResponse {
    return new ListSessionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSessionsResponse {
    return new ListSessionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSessionsResponse | PlainMessage<ListSessionsResponse> | undefined, b: ListSessionsResponse | PlainMessage<ListSessionsResponse> | undefined): boolean {
    return proto3.util.equals(ListSessionsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateSessionRequest
 */
export class UpdateSessionRequest extends Message<UpdateSessionRequest> {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId = "";

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional gitpod.v1.SessionPhase phase = 4;
   */
  phase?: SessionPhase;

  /**
   * @generated from field: optional string orchestrator_agent_execution_id = 5;
   */
  orchestratorAgentExecutionId?: string;

  constructor(data?: PartialMessage<UpdateSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "phase", kind: "enum", T: proto3.getEnumType(SessionPhase), opt: true },
    { no: 5, name: "orchestrator_agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSessionRequest {
    return new UpdateSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSessionRequest {
    return new UpdateSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSessionRequest {
    return new UpdateSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSessionRequest | PlainMessage<UpdateSessionRequest> | undefined, b: UpdateSessionRequest | PlainMessage<UpdateSessionRequest> | undefined): boolean {
    return proto3.util.equals(UpdateSessionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateSessionResponse
 */
export class UpdateSessionResponse extends Message<UpdateSessionResponse> {
  /**
   * @generated from field: gitpod.v1.Session session = 1;
   */
  session?: Session;

  constructor(data?: PartialMessage<UpdateSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session", kind: "message", T: Session },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSessionResponse {
    return new UpdateSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSessionResponse {
    return new UpdateSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSessionResponse {
    return new UpdateSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSessionResponse | PlainMessage<UpdateSessionResponse> | undefined, b: UpdateSessionResponse | PlainMessage<UpdateSessionResponse> | undefined): boolean {
    return proto3.util.equals(UpdateSessionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteSessionRequest
 */
export class DeleteSessionRequest extends Message<DeleteSessionRequest> {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId = "";

  /**
   * @generated from field: bool force = 2;
   */
  force = false;

  constructor(data?: PartialMessage<DeleteSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "force", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteSessionRequest {
    return new DeleteSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteSessionRequest {
    return new DeleteSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteSessionRequest {
    return new DeleteSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteSessionRequest | PlainMessage<DeleteSessionRequest> | undefined, b: DeleteSessionRequest | PlainMessage<DeleteSessionRequest> | undefined): boolean {
    return proto3.util.equals(DeleteSessionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteSessionResponse
 */
export class DeleteSessionResponse extends Message<DeleteSessionResponse> {
  constructor(data?: PartialMessage<DeleteSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteSessionResponse {
    return new DeleteSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteSessionResponse {
    return new DeleteSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteSessionResponse {
    return new DeleteSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteSessionResponse | PlainMessage<DeleteSessionResponse> | undefined, b: DeleteSessionResponse | PlainMessage<DeleteSessionResponse> | undefined): boolean {
    return proto3.util.equals(DeleteSessionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AddSessionResourceRequest
 */
export class AddSessionResourceRequest extends Message<AddSessionResourceRequest> {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId = "";

  /**
   * @generated from field: gitpod.v1.SessionResourceKind kind = 2;
   */
  kind = SessionResourceKind.UNSPECIFIED;

  /**
   * @generated from field: gitpod.v1.SessionResourceRole role = 3;
   */
  role = SessionResourceRole.UNSPECIFIED;

  /**
   * @generated from field: string url = 6;
   */
  url = "";

  /**
   * @generated from field: string title = 7;
   */
  title = "";

  /**
   * @generated from field: string description = 8;
   */
  description = "";

  constructor(data?: PartialMessage<AddSessionResourceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AddSessionResourceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "kind", kind: "enum", T: proto3.getEnumType(SessionResourceKind) },
    { no: 3, name: "role", kind: "enum", T: proto3.getEnumType(SessionResourceRole) },
    { no: 6, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddSessionResourceRequest {
    return new AddSessionResourceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddSessionResourceRequest {
    return new AddSessionResourceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddSessionResourceRequest {
    return new AddSessionResourceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AddSessionResourceRequest | PlainMessage<AddSessionResourceRequest> | undefined, b: AddSessionResourceRequest | PlainMessage<AddSessionResourceRequest> | undefined): boolean {
    return proto3.util.equals(AddSessionResourceRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AddSessionResourceResponse
 */
export class AddSessionResourceResponse extends Message<AddSessionResourceResponse> {
  /**
   * @generated from field: gitpod.v1.SessionResource resource = 1;
   */
  resource?: SessionResource;

  constructor(data?: PartialMessage<AddSessionResourceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AddSessionResourceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resource", kind: "message", T: SessionResource },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddSessionResourceResponse {
    return new AddSessionResourceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddSessionResourceResponse {
    return new AddSessionResourceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddSessionResourceResponse {
    return new AddSessionResourceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AddSessionResourceResponse | PlainMessage<AddSessionResourceResponse> | undefined, b: AddSessionResourceResponse | PlainMessage<AddSessionResourceResponse> | undefined): boolean {
    return proto3.util.equals(AddSessionResourceResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RemoveSessionResourceRequest
 */
export class RemoveSessionResourceRequest extends Message<RemoveSessionResourceRequest> {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId = "";

  /**
   * @generated from field: string resource_id = 2;
   */
  resourceId = "";

  constructor(data?: PartialMessage<RemoveSessionResourceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RemoveSessionResourceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RemoveSessionResourceRequest {
    return new RemoveSessionResourceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RemoveSessionResourceRequest {
    return new RemoveSessionResourceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RemoveSessionResourceRequest {
    return new RemoveSessionResourceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RemoveSessionResourceRequest | PlainMessage<RemoveSessionResourceRequest> | undefined, b: RemoveSessionResourceRequest | PlainMessage<RemoveSessionResourceRequest> | undefined): boolean {
    return proto3.util.equals(RemoveSessionResourceRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RemoveSessionResourceResponse
 */
export class RemoveSessionResourceResponse extends Message<RemoveSessionResourceResponse> {
  constructor(data?: PartialMessage<RemoveSessionResourceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RemoveSessionResourceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RemoveSessionResourceResponse {
    return new RemoveSessionResourceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RemoveSessionResourceResponse {
    return new RemoveSessionResourceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RemoveSessionResourceResponse {
    return new RemoveSessionResourceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RemoveSessionResourceResponse | PlainMessage<RemoveSessionResourceResponse> | undefined, b: RemoveSessionResourceResponse | PlainMessage<RemoveSessionResourceResponse> | undefined): boolean {
    return proto3.util.equals(RemoveSessionResourceResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateSessionResourceRequest
 */
export class UpdateSessionResourceRequest extends Message<UpdateSessionResourceRequest> {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId = "";

  /**
   * @generated from field: string resource_id = 2;
   */
  resourceId = "";

  /**
   * @generated from field: optional gitpod.v1.SessionResourceRole role = 3;
   */
  role?: SessionResourceRole;

  /**
   * @generated from field: optional string title = 4;
   */
  title?: string;

  /**
   * @generated from field: optional string description = 5;
   */
  description?: string;

  constructor(data?: PartialMessage<UpdateSessionResourceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateSessionResourceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "role", kind: "enum", T: proto3.getEnumType(SessionResourceRole), opt: true },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSessionResourceRequest {
    return new UpdateSessionResourceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSessionResourceRequest {
    return new UpdateSessionResourceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSessionResourceRequest {
    return new UpdateSessionResourceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSessionResourceRequest | PlainMessage<UpdateSessionResourceRequest> | undefined, b: UpdateSessionResourceRequest | PlainMessage<UpdateSessionResourceRequest> | undefined): boolean {
    return proto3.util.equals(UpdateSessionResourceRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateSessionResourceResponse
 */
export class UpdateSessionResourceResponse extends Message<UpdateSessionResourceResponse> {
  /**
   * @generated from field: gitpod.v1.SessionResource resource = 1;
   */
  resource?: SessionResource;

  constructor(data?: PartialMessage<UpdateSessionResourceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateSessionResourceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resource", kind: "message", T: SessionResource },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSessionResourceResponse {
    return new UpdateSessionResourceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSessionResourceResponse {
    return new UpdateSessionResourceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSessionResourceResponse {
    return new UpdateSessionResourceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSessionResourceResponse | PlainMessage<UpdateSessionResourceResponse> | undefined, b: UpdateSessionResourceResponse | PlainMessage<UpdateSessionResourceResponse> | undefined): boolean {
    return proto3.util.equals(UpdateSessionResourceResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListSessionResourcesRequest
 */
export class ListSessionResourcesRequest extends Message<ListSessionResourcesRequest> {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId = "";

  /**
   * @generated from field: optional gitpod.v1.SessionResourceKind kind = 2;
   */
  kind?: SessionResourceKind;

  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 3;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<ListSessionResourcesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListSessionResourcesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "kind", kind: "enum", T: proto3.getEnumType(SessionResourceKind), opt: true },
    { no: 3, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSessionResourcesRequest {
    return new ListSessionResourcesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSessionResourcesRequest {
    return new ListSessionResourcesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSessionResourcesRequest {
    return new ListSessionResourcesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSessionResourcesRequest | PlainMessage<ListSessionResourcesRequest> | undefined, b: ListSessionResourcesRequest | PlainMessage<ListSessionResourcesRequest> | undefined): boolean {
    return proto3.util.equals(ListSessionResourcesRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListSessionResourcesResponse
 */
export class ListSessionResourcesResponse extends Message<ListSessionResourcesResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.SessionResource resources = 2;
   */
  resources: SessionResource[] = [];

  constructor(data?: PartialMessage<ListSessionResourcesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListSessionResourcesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "resources", kind: "message", T: SessionResource, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSessionResourcesResponse {
    return new ListSessionResourcesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSessionResourcesResponse {
    return new ListSessionResourcesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSessionResourcesResponse {
    return new ListSessionResourcesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSessionResourcesResponse | PlainMessage<ListSessionResourcesResponse> | undefined, b: ListSessionResourcesResponse | PlainMessage<ListSessionResourcesResponse> | undefined): boolean {
    return proto3.util.equals(ListSessionResourcesResponse, a, b);
  }
}

